import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {},
  hamburgerIcon: {
    width: 22,
    height: 17,
  },
  backArrow: {
    width: 19,
    height: 17,
  },
  backArrowReverse: {
    transform: "rotate(180deg)",
  },
}));

export default useStyles;
